import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppShell } from './components/shell/AppShell';
import { OfflineBanner } from './components/shared/OfflineBanner';
import { ToastContainer } from './components/shared/ToastContainer';
import { ErrorBoundary } from './components/shared/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <div
          className="h-full flex flex-col"
          style={{ backgroundColor: 'var(--bg-base)' }}
        >
          <OfflineBanner />
          <div className="flex-1 flex flex-col overflow-hidden">
            <Routes>
              <Route path="/" element={<AppShell />} />
            </Routes>
          </div>
          <ToastContainer />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export { App };
